import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

import {ComparisonRowKey} from '../types/ComparisonRowKey';
import {ComparisonHoverCell} from './ComparisonHoverCell';

interface ComparisonRowProps {
  children: ReactNode;
  index?: number;
  rowKey: ComparisonRowKey;
}

export const ComparisonRow = (props: ComparisonRowProps) => {
  const isEven = (props.index ?? 0) % 2 === 0;
  return (
    <ComparisonHoverCell rowKey={props.rowKey}>
      <Box
        paddingHorizontal={2}
        paddingVertical={1}
        backgroundColor={isEven ? 'general.white' : 'palettes.neutral.10.100'}
      >
        {props.children}
      </Box>
    </ComparisonHoverCell>
  );
};
